export enum DataType {
    BIT8 = 5,
    BIT16LoHi = 10,
    BIT16HiLo = 15,
    BIT32LoHi = 20,
    BIT32HiLo = 25,
    FLOATLoHi = 30,
    FLOATHiLo = 35,
}
